import { useQuizContext } from "./QuizContext";
import { isDogIncluded } from "@/helpers/dogInclusion";

/**
 * Shared include/exclude control for the plan and review steps (issue #50).
 *
 * The last included dog can never be switched off — a £0 box is not a state
 * the funnel supports — so `setDogIncluded(id, false)` is a no-op when only
 * one dog remains included. Callers should also disable that toggle visually
 * via `includedCount`.
 */
export function useDogInclusion() {
    const { state, dispatch } = useQuizContext();

    const includedDogIds = state.dogOrder.filter((id) =>
        isDogIncluded(state.dogForms[id])
    );

    const isIncluded = (dogId: string) => isDogIncluded(state.dogForms[dogId]);

    const setDogIncluded = (dogId: string, included: boolean) => {
        if (!included && isIncluded(dogId) && includedDogIds.length <= 1) return;
        dispatch({
            type: "UPDATE_DOG_FORM",
            dogId,
            payload: { excludedFromBox: !included },
        });
    };

    return {
        includedDogIds,
        includedCount: includedDogIds.length,
        isIncluded,
        setDogIncluded,
    };
}
